
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"},"content":"<g fill=\"currentColor\"><path d=\"M21.628 11.093c0-3.261-4.004-5.905-8.943-5.905S3.742 7.83 3.743 11.093c0 1.421.76 2.725 2.027 3.744.218 2.124-.8 3.414-1.488 4.178 2.113.552 4.288-1.158 5.277-2.388.973.24 2.026.372 3.126.372 4.939 0 8.943-2.645 8.943-5.906ZM3.803 20.99l-3.226-.844 2.272-2.523c.579-.642.895-1.179.972-1.849-1.295-1.31-2.04-2.926-2.04-4.68 0-4.63 5.017-7.944 10.904-7.944S23.59 6.464 23.59 11.093c0 4.63-5.017 7.943-10.904 7.943-.83 0-1.65-.066-2.445-.196-1.76 1.712-4.137 2.751-6.437 2.15Z\"/><g transform=\"translate(7.611 9.674)\"><ellipse cx=\"5.191\" cy=\"1.354\" rx=\"1.298\" ry=\"1.354\"/><ellipse cx=\"9.084\" cy=\"1.354\" rx=\"1.298\" ry=\"1.354\"/><ellipse cx=\"1.298\" cy=\"1.354\" rx=\"1.298\" ry=\"1.354\"/></g></g>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest && dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
